import { removeDiacritics } from '../../common/utils/removeDiacritics';
import { removeNonAlphaCharacters } from '../../common/utils/removeNonAlphaCharacters';
import { removeWhitespace } from '../../common/utils/removeWhitespace';
import { fetchJson } from '../store/fetch';

const minUserNameLength = 4;
const minSuffixLength = 2;

export async function generateUserName(nameDetails: { nameFamily: string; nameGiven?: string | null }) {
    let userName = getNormalizedUserName(nameDetails);

    if ((await isUserNameInUse(userName)) || userName.length < minUserNameLength) {
        const suffixLength = Math.max(minUserNameLength - userName.length, minSuffixLength);
        userName = userName.padEnd(
            minUserNameLength,
            Math.floor(Math.random() * Math.pow(10, suffixLength)).toString()
        );
    }

    return userName;
}

function getNormalizedUserName(nameDetails: { nameFamily: string; nameGiven?: string | null | undefined }) {
    const nameGiven = nameDetails.nameGiven ? `${normalize(nameDetails.nameGiven)}.` : '';

    return `${nameGiven}${normalize(nameDetails.nameFamily)}`;
}

function normalize(namePart: string) {
    return removeWhitespace(removeNonAlphaCharacters(removeDiacritics(namePart))).toLowerCase();
}

async function isUserNameInUse(userName: string) {
    const result = await fetchJson('/api/practitioners/list', 'POST', {
        filters: {
            userName,
        },
    });

    return result.json.total > 0;
}
